import * as React from 'react';
import { useCallback, useEffect, useState } from 'react';
import * as RiIcons from 'react-icons/ri';

import { useLocation } from '@reach/router';
import useScrollPosition from '@react-hook/window-scroll';
import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';

import { useMixpanel } from '../../functions/Mixpanel';
import '../global.css';

import Dropdown from './Dropdown';
import * as style from './Header.module.css';
import { MainMenu } from './MenuItems';

const Header = ({ pageName, pageCategory, link }) => {
  const { mixpanel } = useMixpanel();
  const trackHeader = useCallback(
    (title) => {
      mixpanel.track('Navigate Header', { 'Header Tab': title });
    },
    [mixpanel],
  );

  const trackButton = useCallback(
    (page_name, button_name) => {
      mixpanel.track(button_name, {
        'Page Name': page_name,
        Section: 'Header',
      });
    },
    [mixpanel],
  );

  const [showDropdown, setShowDropdown] = React.useState(-1);

  const showDropdownonClick = (index) => {
    setShowDropdown((activeIndex) => {
      if (activeIndex === index) {
        return -1;
      } else {
        return index;
      }
    });
  };

  const url = useLocation();
  const [topLevelActive, setTopLevelActive] = useState([]);

  let itemsWithSubMenu = [];

  MainMenu.forEach((item) => {
    item.subMenu && itemsWithSubMenu.push(item);
  });

  useEffect(() => {
    const NoOfItems = itemsWithSubMenu.length;
    setTopLevelActive(new Array(NoOfItems).fill(false));

    MainMenu.forEach((item) => {
      item.subMenu?.forEach((subItem) => {
        if (url.href?.includes(subItem.path)) {
          setTopLevelActive((currentTopLevel) => {
            currentTopLevel[item.position] = true;

            return currentTopLevel;
          });
        }
      });
    });
  }, [url.href, itemsWithSubMenu.length]);

  const scrollY = useScrollPosition();
  const [y, setY] = useState(scrollY);
  const [scrollUp, setScrollUp] = useState(false);

  const handleNavigationAndChangeBackground = useCallback(
    (e) => {
      const window = e.currentTarget;
      if (y > window.scrollY) {
        setScrollUp(true);
      } else if (y < window.scrollY) {
        setScrollUp(false);
      }

      setY(window.scrollY);
    },
    [y],
  );

  React.useEffect(() => {
    setY(window.scrollY);
    window.addEventListener('scroll', handleNavigationAndChangeBackground);
    return () => {
      window.removeEventListener('scroll', handleNavigationAndChangeBackground);
    };
  }, [handleNavigationAndChangeBackground]);

  return (
    <nav
      className={
        scrollY < 40
          ? style.activeNavbar
          : scrollUp
          ? style.scrollingUpNavbar
          : style.hiddenNavbar
      }
    >
      <div
        className={
          pageName !== 'Blog Content' ? style.header : style.blogHeader
        }
      >
        <div className={style.logoContainer}>
          <Link to="/">
            <StaticImage
              src="../../images/gradientLogo.png"
              alt="Logo"
              objectFit="contain"
              placeholder="tracedSVG"
            />
          </Link>
        </div>
        <nav>
          <ul className={style.headerUl}>
            {MainMenu.map((item, index) => {
              if (item.subMenu) {
                return (
                  <div className={style.navText} key={index}>
                    <li
                      key={index}
                      onClick={() => showDropdownonClick(index)}
                      role="presentation"
                      onMouseEnter={() => showDropdownonClick(index)}
                      onMouseLeave={() => showDropdownonClick(-1)}
                    >
                      <Link
                        to=""
                        className={
                          topLevelActive[index]
                            ? style.activeLink
                            : style.headerLinks
                        }
                        onClick={() => trackHeader(item.title)}
                      >
                        {item.title}
                        {/* <span> */}
                        <RiIcons.RiArrowDownSLine size={24} />
                        {/* </span> */}
                      </Link>
                      {showDropdown === index ? (
                        <Dropdown item={item} key={index} />
                      ) : null}
                    </li>
                  </div>
                );
              }
              return (
                <div className={style.navText} key={index}>
                  <li key={index}>
                    <Link
                      to={item.path}
                      className={style.headerLinks}
                      activeClassName="active"
                      onClick={() => trackHeader(item.title)}
                    >
                      {item.title}
                    </Link>
                  </li>
                </div>
              );
            })}
            <div className={style.test}>
              {pageCategory === 'patient' ? (
                //pagecategory should either be patient or clinic
                <a
                  href={link}
                  target="_blank"
                  rel="noreferrer"
                  className={style.requestDemo}
                  onClick={() => trackButton(pageName, 'Download Patient App')}
                >
                  Download App
                </a>
              ) : (
                <a
                  href={link ? link : '/request-a-demo'}
                  className={style.requestDemo}
                  onClick={() => trackButton(pageName, 'Request Demo')}
                  tabIndex="0"
                >
                  Request a demo
                </a>
              )}
            </div>
          </ul>
        </nav>
      </div>
    </nav>
  );
};

export default Header;
